import { all, call, put, takeLatest, fork } from 'redux-saga/effects';
import {
  Creators as SubstrateActions,
  Types as SubstrateTypes,
} from 'store/ducks/Substrate';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getSubstrate({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/substrates`, {
      params: payload,
    });
    if (status === 200) {
      yield put(SubstrateActions.getSubstrateListSuccess(data));
    } else {
      Sentry.captureMessage('getSubstrate failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(SubstrateActions.getSubstrateListFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(SubstrateActions.getSubstrateListFail());
  }
}

function* deleteSubstrate({ payload }) {
  try {
    const { status } = yield call(api.delete, `/substrates/${payload}`);
    if (status === 200) {
      yield put(SubstrateActions.deleteSubstrateSuccess());
    } else {
      Sentry.captureMessage('deleteSubstrate failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(SubstrateActions.deleteSubstrateFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(SubstrateActions.deleteSubstrateFail());
  }
}

function* createSubstrate({ payload }) {
  try {
    const { status } = yield call(api.post, '/substrates', payload);
    if (status === 200) {
      yield put(SubstrateActions.createSubstrateSuccess());
    } else {
      Sentry.captureMessage('createSubstrate failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(SubstrateActions.createSubstrateFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(SubstrateActions.createSubstrateFail());
  }
}

function* getIdSubstrate({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/substrates/${payload}`);
    if (status === 200) {
      yield put(SubstrateActions.getIdSubstrateSuccess(data));
    } else {
      Sentry.captureMessage('getIdSubstrate failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(SubstrateActions.getIdSubstrateFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(SubstrateActions.getIdSubstrateFail());
  }
}

function* updateSubstrate({ payload }) {
  try {
    const { status } = yield call(
      api.put,
      `/substrates/${payload.id}`,
      payload.data
    );
    if (status === 200) {
      yield put(SubstrateActions.updateSubstrateSuccess());
    } else {
      Sentry.captureMessage('updateSubstrate failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(SubstrateActions.updateSubstrateFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(SubstrateActions.updateSubstrateFail());
  }
}

function* getSubstrateWatcher() {
  yield takeLatest(SubstrateTypes.GET_SUBSTRACT_LIST_REQUEST, getSubstrate);
}

function* deleteSubstrateWatcher() {
  yield takeLatest(SubstrateTypes.DELETE_SUBSTRACT_REQUEST, deleteSubstrate);
}

function* createSubstrateWatcher() {
  yield takeLatest(SubstrateTypes.CREATE_SUBSTRACT_REQUEST, createSubstrate);
}

function* getIdSubstrateWatcher() {
  yield takeLatest(SubstrateTypes.GET_ID_SUBSTRACT_REQUEST, getIdSubstrate);
}

function* updateSubstrateWatcher() {
  yield takeLatest(SubstrateTypes.UPDATE_SUBSTRACT_REQUEST, updateSubstrate);
}

export default function* rootSaga() {
  yield all([
    fork(getSubstrateWatcher),
    fork(deleteSubstrateWatcher),
    fork(createSubstrateWatcher),
    fork(getIdSubstrateWatcher),
    fork(updateSubstrateWatcher),
  ]);
}
